export const CommonConstant = {

    toastMessages: {
        FILE_SIZE_100_MB : "File size must be less than 100 MB",
        FILE_FORMAT_CSV : "File must be in CSV format",
        MEDICARE_BENEFICARY_IDENTIFIER_NOT_VALID : "Medicare Number is not valid",
        SSN_IS_NOT_VALID : "SSN is not valid",
        FILL_MANDATORY_FIELDS : "Please fill all mandatory fields",
        MINIMUM_ONE_ADDRESS_REQUIRED : "Minimum one address is required",
        PLEASE_FILE_UPLOAD : "Please upload file",
        INTERNAL_ERROR_OCCUR : "Internal Error Occur",
        RECORD_NOT_SAVED : "Record Not Saved Successfully"
       
    }
   
}